export enum ReviewType {
  AUTO = 'AUTO',
  NEVER = 'NEVER',
}
